var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6H9.75M12.75 6.67939L12.8444 6.60147C14.4313 5.29217 15.2247 4.63752 15.8623 4.95361C16.5 5.26971 16.5 6.31766 16.5 8.41357V9.58643C16.5 11.6824 16.5 12.7303 15.8623 13.0464C15.2247 13.3625 14.4313 12.7078 12.8444 11.3985L12.75 11.3206M1.5 8.25C1.5 5.77513 1.5 4.53769 2.26885 3.76885C3.03769 3 4.27513 3 6.75 3H7.5C9.97485 3 11.2123 3 11.9812 3.76885C12.75 4.53769 12.75 5.77513 12.75 8.25V9.75C12.75 12.2248 12.75 13.4623 11.9812 14.2312C11.2123 15 9.97485 15 7.5 15H6.75C4.27513 15 3.03769 15 2.26885 14.2312C1.5 13.4623 1.5 12.2248 1.5 9.75V8.25Z",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon);
export default __webpack_public_path__ + "static/media/header-icon.2b84826684e4d3da75e4f1943054f98f.svg";
export { ForwardRef as ReactComponent };